module.exports = __webpack_public_path__ + "img/map-terrain.f185eed1.png";